import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';
import themeUsersReducer from './themeUsers/reducers';
import { readMessageReducer } from './message/reducers';
import { readNotificationReducer } from './notification/reducers';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { teamReducer } from './team/reducers';
import { userReducer, userGroupReducer } from './users/reducers';
import { sellersReducer } from './sellers/reducers';
import { headerSearchReducer } from './headerSearch/reducers';
import orderReducer from './orders/reducers';
import galleryReducer from './gallary/reducers';
import chartContentReducer from './chartContent/reducers';
import { productReducer, SingleProductReducer } from './product/reducers';
import { projectReducer, SingleProjectReducer } from './project/reducers';
import cartData from './cart/reducers';
import Task from './task/reducers';
import Profile from './profile/reducers';
import Calender from './calendar/reducers';
import { symbolReducer } from './symbols/reducers';
import { pricingLayoutDailogReducer } from './pricingLayoutDailog/reducers';
import { pdfDocumentAnalysisReducer } from './pdfDocAnalysis/reducers';
import { codeSnippetReducer } from './codeSnippet/reducers';
import { supportDailogReducer } from './support-ticket/reducers';
import { allSymbolDataReducer } from './allSymbols/reducers';
import { emailReducer, SingleEmailReducer } from './email/reducers';
import { userExperimentsDataReducer } from './experiments/reducers';
import { allProductDataReducer } from './products/reducers';
import drawerReducer from './drawer/reducers';

const rootReducers = combineReducers({
  fb: firebaseReducer,
  fs: firestoreReducer,
  allSymbolData: allSymbolDataReducer,
  drawerState: drawerReducer,
  productData: allProductDataReducer,
  themeUsers: themeUsersReducer,
  pricingLayoutDailogReducer,
  pdfDocumentAnalysisReducer,
  codeSnippetReducer,
  supportDailogReducer,
  userExperimentsData: userExperimentsDataReducer,
  symbolData: symbolReducer,
  headerSearchData: headerSearchReducer,
  email: emailReducer,
  emailSingle: SingleEmailReducer,
  message: readMessageReducer,
  notification: readNotificationReducer,
  orders: orderReducer,
  sellers: sellersReducer,
  users: userReducer,
  userGroup: userGroupReducer,
  team: teamReducer,
  auth: authReducer,
  gallery: galleryReducer,
  products: productReducer,
  product: SingleProductReducer,
  projects: projectReducer,
  project: SingleProjectReducer,
  ChangeLayoutMode,
  chartContent: chartContentReducer,
  cart: cartData,
  Task,
  Profile,
  Calender,
});

export default rootReducers;
